import { InjectionToken } from '@angular/core';

/** Injection token for the host app's implementation of the UserSettings interface. */
export const USER_SETTINGS_SERVICE = new InjectionToken('UserSettingsService');